<template>
  <v-app>
    <v-container v-if="object" class="appclick">
      <Header>
        <font-awesome-icon :icon="['fas', 'diagnoses']" />
        <font-awesome-icon :icon="['fas', 'cogs']" />
        <font-awesome-icon :icon="['fas', 'code-branch']" />
        <span class="title">Correct loose ends</span>
      </Header>

      <v-row>
        <v-col class="col-6 Track1"
          ><ImageTrack
            v-if="imagetrackloaded"
            :obj="this.object.obj1"
            :frame="this.object.frame1"
            :mapid="map1"
          />
        </v-col>
        <v-col class="col-6"
          ><ImageTrack
            v-if="imagetrackloaded"
            :obj="this.object.obj2"
            :frame="this.object.frame2"
            :mapid="map2"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col class="col-4">
          <pagination
            v-model="o_slider"
            class="pagination col-xs-12"
            :total-page="n_objects"
            boundary-links
            pills
            @change="changeObject(o_slider)"
          />
        </v-col>
        <v-col class="col-2">
          <font-awesome-icon
            :icon="['fas', 'smile']"
            class="fa-5x"
            style="color:Green"
            @click="connect('green')"
          />Connected<br />
          <font-awesome-icon
            :icon="['fas', 'frown']"
            class="fa-5x"
            style="color:Red"
            @click="connect('red')"
          />Not connected
        </v-col>
        <v-col class="col-6">
          <div id="images">
            <div id="xvideo">
              <video
                id="my-video"
                class="video-js"
                width="630"
                height="420"
                controls
                :currentTime.prop="Math.floor(this.object.frame_first / 30)"
                :src="video"
                type="video/mp4"
              />
              {{ this.object.frame_first }}
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>
<script>
import ProjectService from "@/services/ProjectService.js";
import Header from "@/components/Header.vue";
import ImageTrack from "@/components/ImageTrack.vue";
import Xvideojs from "video.js";

export default {
  data: function() {
    return {
      object: null,
      range1: null,
      range2: null,
      routes: {},
      fields: {},
      objects: {},
      imagetrackloaded: true,
      map1: "map1",
      map2: "map2",
      n_traffic: 0,
      n_nontraffic: 0,
      n_objects: 0,
      o_slider: 1,
      slider: 40,
      n_blocks: 50,
      summary: [],
      video: "",
      zones: {},
      width: 256,
      height: 0.666666 * 216 + 20,
      zoom: 0,
      nid: 0,
      starttijd: 60
    };
  },
  components: {
    Header,
    ImageTrack
  },
  mounted() {
    ProjectService.apiGet({
      nid: this.$session.get("PROJID"),
      type: "correct_loose_ends"
    })
      .then(response => {
        console.log(response.data);
        this.objects = response.data.objects;
        this.n_objects = response.data.n;
        this.fields = response.data.fields;
        this.video = response.data.fields.video;
        this.zones = response.data.zones;
        this.o_slider = 1;
        this.changeObject(this.o_slider);
      })
      .catch(error => {
        console.log("Fout " + error.response);
      });
    this.player = Xvideojs.getPlayer(
      this.$refs.videoPlayer,
      this.options,
      function onPlayerReady() {
        console.log("onPlayerReady", this);
        this.currentTime(100);
        this.play();
      }
    );
  },
  methods: {
    connect(color) {
      if (color == "green") {
        let vars = {
          obj1: this.object.obj1,
          obj2: this.object.obj2
        };
        ProjectService.apiPost({
          type: "correct_loose_ends_update",
          vars
        });
        this.o_slider++;
        this.changeObject(this.o_slider);
      }
    },
    startvideo(ms) {
      let el = document.getElementById("my-video");
      window.setTimeout(function() {
        //  el.play();
      }, 1000);
      window.setTimeout(function() {
        el.pause();
      }, ms);
    },
    test() {
      this.starttijd = 120;
    },
    clickimage(nr) {
      let el = document.getElementById("mapdiv[" + nr + "]");
      if (
        !el.style.backgroundColor ||
        el.style.backgroundColor == "lightblue"
      ) {
        el.style.backgroundColor = "yellow";
        this.n_traffic++;
        this.n_nontraffic--;
      } else {
        el.style.backgroundColor = "lightblue";
        this.n_traffic--;
        this.n_nontraffic++;
        this.n_check_moving--;
      }
    },
    changeObject() {
      this.object = this.objects[this.o_slider];
    }
  }
};
</script>

<style scoped>
.clickimages {
  border-width: thin;
  border-style: solid;
}
.map {
  height: 420px;
  width: 630px;
}
button {
  margin-left: 10px;
  font-size: 10px;
}
.imagetext {
  vertical-align: middle;
}
h6 {
  height: 30px;
}
.video-js {
  height: 286px;
  width: 430px;
}
</style>
